module.exports = __webpack_public_path__ + "static/media/ID.d4c9f34e.svg";